import React, { useState } from 'react';
import tinycolor from 'tinycolor2';
import './AppPreview.css';

// Helper function for lightening colors
const lightenColor = (color, amount = 25) => {
	return tinycolor(color).lighten(amount).toHexString();
};

function AppPreview({ orgData }) {
	const [currentScreen, setCurrentScreen] = useState('home');

	const renderBottomNav = () => (
		<div
			className='bottom-nav'
			style={{ backgroundColor: orgData.primaryColor }}>
			<div
				className={`nav-button ${
					currentScreen === 'home' ? 'active' : ''
				}`}
				onClick={() => setCurrentScreen('home')}>
				<span
					className='material-icons'
					style={{
						color:
							currentScreen === 'home'
								? orgData.secondaryColor
								: lightenColor(orgData.primaryColor, 25),
					}}>
					{currentScreen === 'home' ? 'home' : 'home'}
				</span>
			</div>
			<div
				className={`nav-button ${
					currentScreen === 'menu' ? 'active' : ''
				}`}
				onClick={() => setCurrentScreen('menu')}>
				<span
					className='material-icons'
					style={{
						color:
							currentScreen === 'menu'
								? orgData.secondaryColor
								: lightenColor(orgData.primaryColor, 25),
					}}>
					menu
				</span>
			</div>
		</div>
	);

	const renderScreen = () => {
		return (
			<div className='screen-container'>
				<div className='screen-content'>
					{currentScreen === 'home'
						? renderHomeScreen()
						: renderMenuScreen()}
				</div>
				{renderBottomNav()}
			</div>
		);
	};

	const renderHomeScreen = () => {
		return (
			<div className='app-screen scrollview'>
				<div
					className='header-container'
					style={{
						backgroundImage: orgData.coverImage
							? `url(${orgData.coverImage})`
							: 'url(/dummy-org-cover.jpg)',
					}}>
					<div className='header-content'>
						<div className='row-container'>
							<div className='organization-icon'>
								<img
									src={
										orgData.orgPicture ||
										'/dummy-org-logo.jpg'
									}
									alt='Organization'
								/>
							</div>
							<div className='organization-info'>
								<h2 className='organization-name'>
									{orgData.name}
								</h2>
								<p className='organization-location'>
									{orgData.city}, {orgData.state}
								</p>
							</div>
						</div>
					</div>
				</div>

				<div className='button-container'>
					<button
						className='primary-button'
						style={{ backgroundColor: orgData.primaryColor }}>
						View Calendar
					</button>
				</div>

				<div className='carousel-container'>
					<h3
						className='section-header'
						style={{ color: lightenColor(orgData.primaryColor) }}>
						Announcements
					</h3>
					<div className='carousel'>
						<div
							className='carousel-card'
							style={{
								backgroundColor: lightenColor(
									orgData.primaryColor
								),
								color: '#FFFFFF',
							}}>
							<h4 style={{ color: '#FFFFFF' }}>
								Weekly Devotional Is Available!
							</h4>
							<p style={{ color: '#FFFFFF' }}>
								The Weekly Devotional for this Sunday the 9th
								through this Saturday the 15th is ready to
								start! You can find the plan, the video, and the
								song for the week in the Weekly Devotional
								folder in the media! Let Amy know if you have
								any questions at all!
							</p>
						</div>
						{/* You can keep placeholder cards if needed */}
						{[1, 2].map((i) => (
							<div
								key={i}
								className='carousel-card'
								style={{
									backgroundColor: lightenColor(
										orgData.primaryColor
									),
									color: '#FFFFFF',
								}}>
								<h4 style={{ color: '#FFFFFF' }}>
									Announcement {i}
								</h4>
								<p style={{ color: '#FFFFFF' }}>
									Sample announcement content
								</p>
							</div>
						))}
					</div>
				</div>

				<div className='carousel-container'>
					<h3
						className='section-header'
						style={{ color: lightenColor(orgData.primaryColor) }}>
						Events
					</h3>
					<div className='carousel'>
						<div
							className='carousel-card'
							style={{
								backgroundColor: lightenColor(
									orgData.secondaryColor
								),
								color: '#FFFFFF',
							}}>
							<h4 style={{ color: '#FFFFFF' }}>
								Community Worship Night
							</h4>
							<p style={{ color: '#FFFFFF' }}>
								Join us for a night of worship, fellowship, and
								prayer! Community Worship Night is an
								opportunity for our church family and visitors
								to come together in unity, lifting our voices in
								praise. Expect an uplifting time of live music,
								scripture readings, and a powerful message of
								hope. Light refreshments will be provided. All
								are welcome!
							</p>
						</div>
						{/* You can keep placeholder cards if needed */}
						{[1, 2].map((i) => (
							<div
								key={i}
								className='carousel-card'
								style={{
									backgroundColor: lightenColor(
										orgData.secondaryColor
									),
									color: '#FFFFFF',
								}}>
								<h4 style={{ color: '#FFFFFF' }}>Event {i}</h4>
								<p style={{ color: '#FFFFFF' }}>
									Sample event details
								</p>
							</div>
						))}
					</div>
				</div>

				<div className='button-container bottom-margin'>
					<button
						className='primary-button'
						style={{ backgroundColor: orgData.primaryColor }}>
						Check In
					</button>
				</div>
			</div>
		);
	};

	const menuItems = [
		{
			icon: 'person',
			label: 'Profile',
			route: 'profile',
			isSecondary: true,
		},
		{ icon: 'event', label: 'Events', route: 'events', isSecondary: false },
		{
			icon: 'contact_mail',
			label: 'Contact',
			route: 'contact',
			isSecondary: false,
		},
		{
			icon: 'perm_media',
			label: 'Media',
			route: 'media',
			isSecondary: true,
		},
		{
			icon: 'volunteer_activism',
			label: 'Give',
			route: 'give',
			isSecondary: true,
		},
		{
			icon: 'settings',
			label: 'Settings',
			route: 'settings',
			isSecondary: false,
		},
	];

	const renderMenuScreen = () => {
		return (
			<div className='app-screen scrollview'>
				<div className='menu-header'>
					<div className='user-info'>
						<div className='user-avatar'>
							<span className='material-icons'>
								account_circle
							</span>
						</div>
						<div className='user-details'>
							<h3 style={{ color: orgData.secondaryColor }}>
								John Doe
							</h3>
							<p style={{ color: orgData.secondaryColor }}>
								{orgData.name}
							</p>
						</div>
					</div>
					<button className='sign-out-button'>
						<span
							className='material-icons'
							style={{ color: orgData.secondaryColor }}>
							logout
						</span>
					</button>
				</div>

				<div className='menu-grid'>
					{menuItems.map((item, index) => (
						<div
							key={index}
							className='menu-square'
							onClick={() => setCurrentScreen(item.route)}
							style={{
								backgroundColor: item.isSecondary
									? orgData.secondaryColor
									: orgData.primaryColor,
								border: `2px solid ${orgData.accentColor}`,
								color: item.isSecondary
									? orgData.primaryColor
									: orgData.secondaryColor,
							}}>
							<span className='material-icons'>{item.icon}</span>
							<span>{item.label}</span>
						</div>
					))}
				</div>

				<div className='menu-buttons'>
					<button
						className='primary-button'
						style={{
							backgroundColor: orgData.primaryColor,
							color: orgData.secondaryColor,
						}}>
						Check In
					</button>
					<button
						className='secondary-button'
						style={{
							backgroundColor: orgData.secondaryColor,
							color: orgData.primaryColor,
							border: `2px solid ${orgData.accentColor}`,
						}}>
						Switch
					</button>
				</div>
			</div>
		);
	};

	return (
		<div className='app-preview-container'>
			<div className='phone-frame'>
				<div className='phone-header'>
					<div className='phone-speaker'></div>
					<div className='phone-camera'></div>
				</div>
				<div
					className='phone-content gradient-background'
					style={{
						background: `linear-gradient(to bottom, ${
							orgData.primaryColor || '#4b95a3'
						}, ${orgData.secondaryColor || '#791951'})`,
					}}>
					{renderScreen()}
				</div>
				<div className='phone-home-button'></div>
			</div>
		</div>
	);
}

export default AppPreview;
